import * as constants from '../../constants';

export const sprite = new PIXI.Sprite();
sprite.interactive = true;
sprite.cursor = 'pointer';

export const width = 70;
const height = constants.headerHeight;

export const setShowExitModal = fn => {
  sprite.on('pointerdown', () => fn());
};

const g = new PIXI.Graphics();
sprite.addChild(g);
g.beginFill(constants.red).drawRect(0, 0, width, height).endFill();

const text = new PIXI.Text('EXIT', {
  font: '15px Open Sans, Arial',
  fill: 0xFFFFFF,
  align: 'center'
});
sprite.addChild(text);
text.anchor.set(0.5);
text.position.set(width / 2, height / 2);
